module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-fir-b116d8271d0f73873bbaa2c15a7c51eb.png";